(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    var form = document.getElementById('eofyEnquiryForm');
    var errorSummary = document.getElementById('eofyErrorSummary');

    // Handle successful form submission redirect
    if (window.location.hash === '#contact_form' || document.querySelector('.form-success')) {
      openEnquiryModal();
      var submitBtn = document.querySelector('#eofyEnquiryForm .modal-submit');
      if (submitBtn && typeof SardenFormValidator !== 'undefined') {
        SardenFormValidator.setButtonSuccess(submitBtn);
        submitBtn.disabled = true;
      }
      setTimeout(function() {
        closeModalById('enquiryModal');
        if (window.history.replaceState) {
          window.history.replaceState(null, null, window.location.pathname);
        }
      }, 2500);
    }

    // Form validation and submit
    if (form) {
      form.addEventListener('submit', function(e) {
        if (typeof SardenFormValidator !== 'undefined') {
          return SardenFormValidator.handleShopifySubmit(e, {
            form: form,
            errorSummary: errorSummary,
            fields: [
              { id: 'eofy-modal-name', rules: { required: true } },
              { id: 'eofy-modal-email', rules: { required: true, email: true } },
              { id: 'eofy-modal-organisation', rules: { required: true } }
            ]
          });
        }
      });
    }
  });

  // Email bot protection
  document.addEventListener('DOMContentLoaded', function() {
    var emailSpan = document.querySelector('.eofy-cta-email-text');
    if (emailSpan) {
      var user = emailSpan.getAttribute('data-user');
      var domain = emailSpan.getAttribute('data-domain');
      if (user && domain) {
        emailSpan.textContent = user + '@' + domain;
      }
    }
  });

  window.eofySendEmail = function() {
    var emailSpan = document.querySelector('.eofy-cta-email-text');
    if (emailSpan) {
      var user = emailSpan.getAttribute('data-user');
      var domain = emailSpan.getAttribute('data-domain');
      if (user && domain) {
        window.location.href = 'mailto:' + user + '@' + domain;
      }
    }
  };

})();
